import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20product%20photography%20with%20premium%20sneakers%20and%20luxury%20accessories%20artistically%20arranged%20on%20rich%20marble%20surface%20dark%20charcoal%20backdrop%20golden%20accent%20rim%20lighting%20creating%20depth%20and%20elegance%20moody%20sophisticated%20atmosphere%20high-end%20retail%20catalog%20aesthetic%20sharp%20focus%20on%20textures&width=1800&height=1200&seq=kakobuy-hero-v2-unique&orientation=landscape"
          alt="Kakobuy Finds - Curated shopping spreadsheet products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-[1440px] mx-auto">
        <div className="max-w-2xl">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-tight">
            Kakobuy Spreadsheet
            <br />
            <span className="text-accent-300">2026 Best Finds</span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-background-50/80 leading-relaxed max-w-xl font-light">
            Discover the most organized shopping spreadsheet with 500+ curated finds across 14 categories. Updated weekly with trending products and verified shopping lists.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-all duration-200 cursor-pointer"
            >
              Explore Kakobuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <Link
              to="/article/kakobuy-spreadsheet-ultimate-guide"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border-2 border-background-50/50 text-background-50 font-semibold text-base hover:bg-background-50/10 transition-all duration-200 cursor-pointer"
            >
              Read Ultimate Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-10 md:pb-14">
        <div className="px-6 md:px-10 max-w-[1440px] mx-auto">
          <p className="font-heading text-5xl md:text-8xl lg:text-9xl font-black text-background-50/15 leading-none tracking-tighter select-none">
            SMARTER SHOPPING STARTS HERE
          </p>
        </div>
      </div>
    </section>
  );
}